import { HTMLChakraProps } from '@chakra-ui/react'
import { Flex, Heading } from 'front-end/src/components'
import IconTick from 'front-end/src/components/common/icon/IconTick'
import ProgressRing from 'front-end/src/components/common/progress-ring/ProgressRing'
import React, { FC } from 'react'
import { brandColors } from 'shared/basicPalette'

export interface IEditModeVideoProgressRowProps {
  progress: number
  withPercentage?: boolean
  children?: any
}

export const EditModeVideoProgressRow: FC<IEditModeVideoProgressRowProps> = (
  props
) => {
  const { progress, withPercentage, children } = props

  return (
    <Flex
      direction="row"
      alignItems="center"
      maxWidth="580px"
      width="100%"
      mb="24px"
      _lastChild={{ mb: 0 }}
    >
      <Flex width="60px" justifyContent="center">
        {progress === 100 ? (
          <IconTick />
        ) : (
          <ProgressRing progress={progress} withPercentage={withPercentage} />
        )}
      </Flex>

      <Flex
        direction="column"
        textAlign="left"
        ml="32px"
        color={brandColors.grey.mid}
      >
        {children}
      </Flex>
    </Flex>
  )
}

export const EditModeVideoProgressHeading: FC<
  {
    children: any
  } & HTMLChakraProps<typeof Heading>
> = (props) => {
  const { children, ...restProps } = props

  return (
    <Heading
      color={brandColors.grey.light}
      fontWeight="500"
      size="md"
      as="h3"
      {...restProps}
    >
      {children}
    </Heading>
  )
}

export const EditModeVideoProgressWrapper: FC<{ children: any }> = ({
  children
}) => {
  return (
    <Flex
      direction="column"
      height="100%"
      justifyContent="center"
      alignItems="center"
    >
      {children}
    </Flex>
  )
}
